export const FILES_REPOSITORY_FEATURE_KEYS = {
  VIEW: 'FILES_REPOSITORY_VIEW',
  DELETE: 'FILES_REPOSITORY_DELETE',
  CREATE_FOLDER: 'FILES_REPOSITORY_CREATE_FOLDER',
  CREATE_FILE: 'FILES_REPOSITORY_CREATE_FILE'
} as const;

export const PROJECTS_FEATURE_KEYS = {
  ALL_PROJECTS: 'PROJECTS_ALL_PROJECTS',
  ARCHIVED_PROJECTS: 'PROJECTS_ARCHIVED_PROJECTS',
  NEW_PROJECT: 'PROJECTS_NEW_PROJECT',
  EDIT: 'PROJECTS_EDIT',
  ASSIGN_TEMPLATE: 'PROJECTS_ASSIGN_TEMPLATE',
  USERS: 'PROJECTS_USERS',
  ARCHIVE: 'PROJECTS_ARCHIVE'
} as const;

export const APP_MENU_FEATURE_KEYS = {
  HOME: 'MENU_HOME',
  PROJECTS: 'MENU_PROJECTS',
  USER_MANAGEMENT: 'MENU_USER_MANAGEMENT',
  ROLE_MANAGEMENT: 'MENU_ROLE_MANAGEMENT',
  TEMPLATES: 'MENU_TEMPLATES',
  TASK_MANAGEMENT: 'MENU_TASK_MANAGEMENT',
  FILE_SETTINGS: 'MENU_FILE_SETTINGS',
  FILES: 'MENU_FILES',
  PRIVACY_POLICY: 'MENU_PRIVACY_POLICY',
  APP_VERSIONS: 'MENU_APP_VERSIONS',
  INTEGRATIONS: 'MENU_INTEGRATIONS',
  BLOCK_SCHEDULE: 'MENU_BLOCK_SCHEDULE',
  MAPS: 'MENU_MAPS',
} as const;

export interface AppSidebarMenuItem {
  label: string;
  icon: string;
  routerLink: string[];
  featureKey: string;
}
